import React, { useState, useEffect, useRef } from 'react';
import { doc, getDoc, setDoc, updateDoc, deleteField } from 'firebase/firestore';
import { db } from './firebase';
import { C } from './constants';
import { getPeriodeInfo } from './App';
import { RACCOURCI_CODE as CODE_CATALOGUE, AdminMajCatalogue } from './MajCatalogueMihi';
import { filtrerAnnuaire, estMelissaUid } from './EquipeGains';

// ─────────────────────────────────────────────────────────────────────────────
// 📥 CHIFFRES MIHI (équipe + moi) — sans mot de passe, pour chaque utilisatrice avec SON compte Mihi
// 1) Un favori « Lire mon équipe Mihi » lit, dans le navigateur déjà connecté à mihi.care :
//    • « Rapport en ligne » (VP, VGP, VG de chaque personne de l'équipe)
//    • « Calcul des bonus » (mes propres VP / VGP / VG et mon statut)
// 2) On colle dans l'app : les chiffres sont gardés dans le compte de la personne (users/{uid} → db-chiffres-mihi).
// 3) Des boutons « Remplir depuis Mihi » (Objectifs, directeurs, tirelire) reprennent ces chiffres.
// Vocabulaire Mihi : VP = volume perso · VGP = volume de groupe perso (sans les groupes des directeurs) · VG = volume du groupe entier.
// ─────────────────────────────────────────────────────────────────────────────

const SCHEMA = 'java' + 'script:';
const RACCOURCI_CODE = "(async function(){try{if(!/(^|\\.)mihi\\.care$/.test(location.hostname)){alert(\"Ouvre d'abord mihi.care (connect\\xE9e \\xE0 ton compte), puis relance ce raccourci.\");return}var f=document.getElementById(\"bd-maj-equipe\");f&&f.remove();var n=document.createElement(\"div\");n.id=\"bd-maj-equipe\",n.style.cssText=\"position:fixed;z-index:2147483647;left:0;right:0;top:12vh;margin:0 auto;width:min(520px,92vw);display:flex;flex-direction:column;background:#fff;color:#3D1F0E;border-radius:16px;box-shadow:0 10px 40px rgba(0,0,0,.35);padding:18px;font:14px/1.45 Arial,sans-serif\",n.innerHTML='<div style=\"font-weight:700;font-size:16px;margin-bottom:6px\">Blazing Dynasty : lecture de ton \\xE9quipe</div><div id=\"bd-etat\">D\\xE9marrage\\u2026</div>',document.body.appendChild(n);for(var l=function(t){var e=document.getElementById(\"bd-etat\");e&&(e.textContent=t)},r=function(t){var e=parseFloat(String(t||\"\").split(\"(\")[0].replace(/[^0-9.\\-]/g,\"\"));return isNaN(e)?0:e},m=function(t){return String(t||\"\").replace(/\\s+/g,\" \").trim()},v=async function(t){var e=await fetch(t,{credentials:\"same-origin\"});return new DOMParser().parseFromString(await e.text(),\"text/html\")},g=document.querySelector(\"select[name=period]\"),x=g?g.value:\"\",i=[],h={},d=\"\",o=1;o<=40;o++){l(\"Lecture de ton \\xE9quipe\\u2026 page \"+o+\" (\"+i.length+\" personnes)\");var y=await v(\"/cabinet/online-report?page=\"+o+(x?\"&period=\"+x:\"\"));if(o===1){var b=y.querySelector(\"select[name=period]\"),w=b&&b.selectedOptions[0],C=w?w.textContent.match(/\\d+-\\d+/):null;d=C?C[0]:\"\"}var q=Array.from(y.querySelectorAll(\"table tbody tr\")),E=0;if(q.forEach(function(t){var e=Array.from(t.children).map(function(k){return m(k.textContent)});if(!(e.length<10)){var a=(e[1]||\"\").replace(/\\D/g,\"\");if(!(!a||h[a])){h[a]=1,E++;var p=(e[11]||\"\").match(/^(\\d+)\\s*(.*)$/);i.push({i:a,n:e[2],vp:r(e[5]),vgp:r(e[6]),vg:r(e[7]),pct:r(e[8]),mi:p?p[1]:\"\",mn:p?p[2]:\"\"})}}}),!E)break}l(\"Lecture de tes propres chiffres\\u2026\");var c=[];try{var D=await v(\"/cabinet/remuneration_calculation\");Array.from(D.querySelectorAll(\"table tr\")).forEach(function(t){var e=Array.from(t.children).map(function(a){return m(a.textContent)});/^\\d+-\\d+$/.test(e[0]||\"\")&&c.push({p:e[0],vp:r(e[1]),vgp:r(e[2]),vg:r(e[3]),pct:r(e[4]),nbDir:r(e[5]),statut:e[6]||\"\"})})}catch{}c=c.slice(-6);var u=null;if(c.forEach(function(t){t.p===d&&(u=t)}),!i.length&&!u){l(\"Je n'ai rien trouv\\xE9 : v\\xE9rifie que tu es bien connect\\xE9e \\xE0 ton compte Mihi.\");return}var S=JSON.stringify({bd:\"equipe-mihi\",version:1,date:new Date().toISOString(),periode:d,moi:u,periodes:c,membres:i});n.innerHTML='<div style=\"font-weight:700;font-size:16px;margin-bottom:6px\">\\u2705 '+i.length+\" personnes lues (campagne \"+(d||\"?\")+')</div><div style=\"margin-bottom:8px\">Clique sur \\xAB Copier \\xBB, puis retourne dans ton app et colle dans la case \\xAB Chiffres Mihi \\xBB.</div><textarea id=\"bd-texte\" readonly style=\"align-self:stretch;height:90px;font:11px monospace;border:1px solid #ccc;border-radius:8px;padding:6px;box-sizing:border-box\"></textarea><div style=\"display:flex;gap:8px;margin-top:10px\"><button id=\"bd-copier\" style=\"flex:1;padding:10px;border:0;border-radius:10px;background:#3D1F0E;color:#fff;font-weight:700;cursor:pointer\">Copier</button><button id=\"bd-fermer\" style=\"padding:10px 14px;border:1px solid #ccc;border-radius:10px;background:#fff;cursor:pointer\">Fermer</button></div><div id=\"bd-ok\" style=\"margin-top:8px;color:#2D5A3D;font-weight:700\"></div>';var s=document.getElementById(\"bd-texte\");s.value=S,document.getElementById(\"bd-fermer\").onclick=function(){n.remove()},document.getElementById(\"bd-copier\").onclick=async function(){var t=!1;try{await navigator.clipboard.writeText(S),t=!0}catch{}if(!t){s.focus(),s.select();try{t=document.execCommand(\"copy\")}catch{}}document.getElementById(\"bd-ok\").textContent=t?\"Copi\\xE9 ! Tu peux coller dans l'app.\":\"S\\xE9lectionne le texte et copie-le (Ctrl+C).\"}}catch(t){alert(\"Oups, la lecture a \\xE9chou\\xE9 : \"+(t&&t.message?t.message:t))}})();";
const RACCOURCI_CODE_EQUIPE = RACCOURCI_CODE;
export const CLE_CHIFFRES = 'db-chiffres-mihi';
const EVENEMENT = 'bd-chiffres-mihi';

const nb = (v) => { const n = parseFloat(v); return isNaN(n) ? 0 : n; };
const txt = (n) => String(Math.round(nb(n) * 100) / 100);
const fmtE = (n) => { const v = Math.round(nb(n) * 100) / 100; return v.toLocaleString('fr-FR', Number.isInteger(v) ? { maximumFractionDigits: 0 } : { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; };

// ── Noms : comparaison sans accents, sans ordre, sans « de / da / du… » ──────
const PARTICULES = new Set(['de', 'da', 'do', 'dos', 'das', 'du', 'des', 'la', 'le', 'van', 'von', 'el']);
export function jetons(nom) {
  const t = String(nom == null ? '' : nom).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
    .replace(/[^a-z0-9\s]/g, ' ').split(/\s+/).filter(Boolean);
  const sans = t.filter((x) => !PARTICULES.has(x));
  return sans.length ? sans : t;
}
export const cleNom = (nom) => jetons(nom).slice().sort().join(' ');

export function trouverPersonne(chiffres, nom, uid = null) {
  const vide = { membre: null, candidats: [] };
  if (!chiffres || !Array.isArray(chiffres.membres) || (!String(nom || '').trim() && !uid)) return vide;
  const k = cleNom(nom);
  const liens = chiffres.liens || {};
  const lien = (uid && liens['uid:' + uid]) || liens[k];
  if (lien) { const m = chiffres.membres.find((x) => x.i === lien); if (m) return { membre: m, candidats: [m], lie: true, sure: true }; }
  // Distributrice marquée à la main (Mihi ne la voit pas dans l'équipe) : son chiffre, s'il y en a un, ne vaut que pour la campagne où il a été saisi
  const man = chiffres.manuels || {};
  const mv = (uid && man['uid:' + uid]) || man[k];
  if (mv) {
    const perime = !!mv.periode && !!chiffres.periode && String(mv.periode) !== String(chiffres.periode);
    const v = perime ? 0 : nb(mv.vgp);
    return { membre: { i: 'manuel:' + (uid || k), n: String(nom || ''), vgp: v, vg: v, pct: 0, mi: '', mn: '', manuel: true, vide: !(v > 0) }, candidats: [], lie: true, sure: true, manuel: true };
  }
  const t = jetons(nom);
  const exacts = chiffres.membres.filter((m) => cleNom(m.n) === k);
  if (exacts.length === 1) return { membre: exacts[0], candidats: exacts, sure: true };
  if (exacts.length > 1) return { membre: null, candidats: exacts };
  const dedans = chiffres.membres.filter((m) => { const mt = jetons(m.n); return t.length >= 1 && t.every((x) => mt.includes(x)); });
  if (dedans.length === 1) return { membre: dedans[0], candidats: dedans, sure: false };
  if (dedans.length > 1) return { membre: null, candidats: dedans };
  const contient = chiffres.membres.filter((m) => { const mt = jetons(m.n); return mt.length >= 2 && mt.every((x) => t.includes(x)); });
  if (contient.length === 1) return { membre: contient[0], candidats: contient, sure: false };
  return { membre: null, candidats: contient };
}

export function lirePaquetEquipe(texte) {
  let d;
  try { d = JSON.parse(String(texte || '').trim()); } catch (e) { throw new Error("Ce texte n'est pas celui du raccourci. Recopie-le en entier (bouton « Copier » sur mihi.care)."); }
  if (d && d.bd === 'catalogue-mihi') throw new Error("Ce texte vient du favori « Lire le catalogue Mihi » : il se colle dans l'« Étape 3 · le catalogue et les prix », juste en dessous de cette case. Pour tes chiffres d'équipe, clique sur le favori « Lire mon équipe Mihi » sur mihi.care.");
  if (!d || d.bd !== 'equipe-mihi' || !Array.isArray(d.membres)) throw new Error("Ce n'est pas le contenu du favori « Lire mon équipe Mihi ». Retourne sur mihi.care, clique sur ce favori puis sur « Copier ».");
  const membres = d.membres.filter((m) => m && m.i && m.n).map((m) => ({ i: String(m.i), n: String(m.n), vgp: nb(m.vgp), vg: nb(m.vg), pct: nb(m.pct), mi: String(m.mi || ''), mn: String(m.mn || '') }));
  const moi = d.moi && typeof d.moi === 'object' ? { p: String(d.moi.p || ''), vgp: nb(d.moi.vgp), vg: nb(d.moi.vg), pct: nb(d.moi.pct), nbDir: nb(d.moi.nbDir), statut: String(d.moi.statut || '') } : null;
  if (!membres.length && !moi) throw new Error("Aucun chiffre dans ce texte : vérifie que tu étais bien connectée à ton compte Mihi quand tu as cliqué sur le favori.");
  return { bd: 'equipe-mihi', version: 1, date: d.date || new Date().toISOString(), periode: String(d.periode || ''), moi, membres };
}

// ── Stockage : un coffre à part, lisible par sa propriétaire SEULEMENT (règle Firestore « chiffres_mihi_perso ») ──
const lireJson = (raw) => {
  if (!raw) return null;
  try { return typeof raw === 'string' ? JSON.parse(raw) : raw; } catch (e) { return null; }
};
export async function lireStock(uid) {
  try {
    const n = await getDoc(doc(db, 'chiffres_mihi_perso', uid));
    const v = n.exists() ? lireJson(n.data().data) : null;
    if (v) return v;
  } catch (e) { /* on regarde l'ancien emplacement */ }
  // Ancien emplacement (dans users/{uid}) : on récupère, on range dans le coffre, puis on l'efface de l'ancien
  const s = await getDoc(doc(db, 'users', uid));
  const ancien = s.exists() ? lireJson(s.data()[CLE_CHIFFRES]) : null;
  if (ancien) {
    try {
      await setDoc(doc(db, 'chiffres_mihi_perso', uid), { data: JSON.stringify(ancien) });
      await updateDoc(doc(db, 'users', uid), { [CLE_CHIFFRES]: deleteField() });
    } catch (e) { /* sera refait la prochaine fois */ }
  }
  return ancien;
}
async function sauverStock(uid, data) {
  await setDoc(doc(db, 'chiffres_mihi_perso', uid), { data: JSON.stringify(data) });
  try { window.dispatchEvent(new CustomEvent(EVENEMENT, { detail: { uid, data } })); } catch (e) { /* ancien navigateur */ }
}

// Marquer à la main une distributrice que Mihi ne voit pas (valeur = son PGV de la campagne, facultatif)
export async function marquerDistributrice(uid, chiffres, nom, puid, valeur) {
  const v = { vgp: nb(String(valeur == null ? '' : valeur).replace(',', '.')), date: Date.now(), periode: chiffres && chiffres.periode ? String(chiffres.periode) : '' };
  const manuels = { ...((chiffres && chiffres.manuels) || {}), [cleNom(nom)]: v };
  if (puid) manuels['uid:' + puid] = v;
  const data = { ...chiffres, manuels };
  try { await sauverStock(uid, data); } catch (e) { /* le marquage sert quand même pour cette fois */ }
  return data;
}
export async function retirerMarquage(uid, chiffres, nom, puid) {
  const manuels = { ...((chiffres && chiffres.manuels) || {}) };
  delete manuels[cleNom(nom)];
  if (puid) delete manuels['uid:' + puid];
  const data = { ...chiffres, manuels };
  try { await sauverStock(uid, data); } catch (e) { /* facultatif */ }
  return data;
}

export function useChiffresMihi(uid) {
  const [chiffres, setChiffres] = useState(undefined); // undefined = chargement, null = rien d'importé
  useEffect(() => {
    let vivant = true;
    if (!uid) { setChiffres(null); return undefined; }
    lireStock(uid).then((d) => { if (vivant) setChiffres(d); }).catch(() => { if (vivant) setChiffres(null); });
    const ecoute = (e) => { if (e.detail && e.detail.uid === uid) setChiffres(e.detail.data); };
    window.addEventListener(EVENEMENT, ecoute);
    return () => { vivant = false; window.removeEventListener(EVENEMENT, ecoute); };
  }, [uid]);
  return chiffres;
}

// ── Tout remplir d'un coup : Objectifs, directeurs en place, directeurs à venir, tirelire ──
// Lit les données de la personne, y reporte les chiffres Mihi, puis les réécrit. Rien n'est supprimé : seuls les chiffres sont remplacés.
export async function appliquerPartout(uid, chiffres) {
  const r = { objectifs: false, ca: 0, directeurs: 0, avenir: 0, tirelire: 0, tirelireIgnoree: false, manquants: [] };
  if (!uid || !chiffres) return r;
  const ref = doc(db, 'users', uid);
  const snap = await getDoc(ref);
  const d = snap.exists() ? snap.data() : {};
  // (plus de lecture de l'annuaire ici)
  const manque = (nom, uid = null) => { if (nom && !r.manquants.some((x) => x.nom === nom && x.uid === uid)) r.manquants.push({ nom, uid }); };
  let periode = '';
  try { periode = String(getPeriodeInfo().periodNum); } catch (e) { periode = ''; }
  const ecriture = {};

  // 1) Objectifs : mon CA, directeurs en place, directeurs à venir
  let obj = null;
  try { obj = d['db-obj-perso'] ? JSON.parse(d['db-obj-perso']) : null; } catch (e) { obj = null; }
  obj = obj && typeof obj === 'object' ? obj : {};
  let objTouche = false;
  if (chiffres.moi) {
    // Le VP (volume perso) de Mihi n'est JAMAIS lu ni repris : il mélange achats perso et ventes clientes. Seul le volume de groupe est utilisé.
    const vg = Math.round(nb(chiffres.moi.vg) * 100) / 100;
    obj.ca = String(vg); obj.caEquipe = String(Math.max(0, Math.round((vg - nb(obj.caPerso)) * 100) / 100));
    r.ca = vg; objTouche = true;
  }
  // Directeurs en place et directeurs à venir : Melissa les remplit à la main, le remplissage Mihi n'y touche pas.
  if (objTouche) { ecriture['db-obj-perso'] = JSON.stringify(obj); r.objectifs = true; }

  // 2) Tirelire « Mon équipe » (seulement si elle est déjà passée à la période en cours)
  let tir = null;
  try { tir = d['db-tirelire'] ? JSON.parse(d['db-tirelire']) : null; } catch (e) { tir = null; }
  if (tir && tir.equipe && Array.isArray(tir.equipe.membres) && tir.equipe.membres.length) {
    if (tir.periode != null && periode && String(tir.periode) !== periode) {
      r.tirelireIgnoree = true;
    } else {
      const membres = tir.equipe.membres.map((m) => {
        const t = trouverPersonne(chiffres, m.nom, m.uid);
        if (t.membre && t.membre.vide) return m;
        if (!t.membre) { manque(m.nom, m.uid || null); return m; }
        r.tirelire++;
        return { ...m, pgvManuel: txt(t.membre.vgp) };
      });
      const equipe = { ...tir.equipe, membres };
      if (r.tirelire) { ecriture['db-tirelire'] = JSON.stringify({ ...tir, equipe }); }
    }
  }

  if (Object.keys(ecriture).length) await setDoc(ref, ecriture, { merge: true });
  // Melissa : son CA total alimente la couronne « Objectifs équipe » de toute l'équipe
  if (r.objectifs && chiffres.moi && estMelissaUid(uid)) {
    try { await setDoc(doc(db, 'equipe', 'objectifs'), { caReal: String(obj.ca), caRealMaj: Date.now() }, { merge: true }); } catch (e) { /* facultatif */ }
  }
  if (r.objectifs && chiffres.moi) {
    try { window.dispatchEvent(new CustomEvent('ventes-maj', { detail: { ca: obj.ca, caPerso: obj.caPerso, caEquipe: obj.caEquipe } })); } catch (e) { /* facultatif */ }
  }
  return r;
}

// ── Partager les chiffres à toute l'équipe (annuaire commun) ─────────────────
// Seules les personnes reconnues sont mises à jour. Les chiffres vont dans un coffre à part (chiffres_equipe) :
// ce que la personne a tapé elle-même n'est jamais effacé, et une personne non reconnue n'est jamais touchée.
export async function lireAnnuaireCommun() {
  const s = await getDoc(doc(db, 'equipe', 'annuaire'));
  return s.exists() ? (s.data().membres || {}) : {};
}

export function classerPartage(chiffres, annuaire, monUid) {
  const sures = [], aConfirmer = [], inconnus = [], manuelles = [];
  Object.entries(annuaire || {}).forEach(([k, a]) => {
    const u = (a && a.uid) || k;
    if (!a || u === monUid) return;
    const nom = `${a.prenom || ''} ${a.nom || ''}`.trim();
    if (!nom) return;
    const t = trouverPersonne(chiffres, nom, u);
    if (t.membre && t.membre.manuel) { manuelles.push({ uid: u, nom, vgp: t.membre.vgp, vide: !!t.membre.vide }); if (!t.membre.vide) sures.push({ uid: u, nom, membre: t.membre }); }
    else if (t.membre) (t.sure ? sures : aConfirmer).push({ uid: u, nom, membre: t.membre });
    else inconnus.push({ uid: u, nom, candidats: t.candidats || [] });
  });
  // Deux personnes de l'app reliées à la même personne Mihi : on ne devine pas, on les met de côté
  const compte = {};
  [...sures, ...aConfirmer].forEach((x) => { compte[x.membre.i] = (compte[x.membre.i] || 0) + 1; });
  const garde = (x) => compte[x.membre.i] === 1;
  const doublons = [...sures, ...aConfirmer].filter((x) => !garde(x)).map((x) => ({ uid: x.uid, nom: x.nom, candidats: [x.membre] }));
  const tri = (a, b) => a.nom.localeCompare(b.nom, 'fr');
  return { sures: sures.filter(garde).sort(tri), aConfirmer: aConfirmer.filter(garde).sort(tri), inconnus: [...inconnus, ...doublons].sort(tri), manuelles: manuelles.sort(tri) };
}

// Toutes les marraines au-dessus d'une personne (sa marraine, la marraine de sa marraine, etc.)
export function ancetresDe(uid, annuaire) {
  const res = [];
  const vus = new Set([uid]);
  let cur = annuaire && annuaire[uid] && annuaire[uid].marraine;
  while (cur && !vus.has(cur)) { res.push(cur); vus.add(cur); cur = annuaire[cur] && annuaire[cur].marraine; }
  return res;
}

// Les chiffres partagés vont dans le coffre « chiffres_equipe/{uid} » : lisible seulement par la personne,
// ses marraines (au-dessus d'elle) et Melissa. Ils ne sont plus dans l'annuaire commun, que tout le monde peut lire.
// annuaireComplet sert uniquement à retrouver les marraines (jamais affiché).
export async function partagerALEquipe(chiffres, personnes, annuaireComplet = {}) {
  const liste = (personnes || []).filter((x) => x && x.uid && x.membre);
  if (!liste.length) return 0;
  const maintenant = Date.now();
  await Promise.all(liste.map(({ uid, membre }) => setDoc(doc(db, 'chiffres_equipe', uid), {
    uid,
    ancetres: ancetresDe(uid, annuaireComplet),
    caMihi: txt(membre.vgp),
    majMihi: maintenant,
    periodeMihi: String(chiffres.periode || ''),
  }, { merge: true })));
  // Nettoyage : les anciens chiffres Mihi déposés dans l'annuaire commun sont effacés
  try {
    const nettoyage = {};
    Object.entries(annuaireComplet || {}).forEach(([k, a]) => {
      if (a && ('caMihi' in a || 'caPersoMihi' in a || 'majMihi' in a || 'periodeMihi' in a)) {
        ['caMihi', 'caPersoMihi', 'majMihi', 'periodeMihi'].forEach((f) => { nettoyage[`membres.${k}.${f}`] = deleteField(); });
      }
    });
    if (Object.keys(nettoyage).length) await updateDoc(doc(db, 'equipe', 'annuaire'), nettoyage);
  } catch (e) { /* facultatif */ }
  return liste.length;
}

export function resumerRemplissage(r) {
  const l = [];
  if (r.objectifs) l.push('Objectifs' + (r.ca ? ' : CA ' + fmtE(r.ca) : ''));
  if (r.directeurs) l.push(r.directeurs + ' directeur' + (r.directeurs > 1 ? 's' : '') + ' en place');
  if (r.avenir) l.push(r.avenir + ' directeur' + (r.avenir > 1 ? 's' : '') + ' à venir');
  if (r.tirelire) l.push('tirelire : ' + r.tirelire + ' personne' + (r.tirelire > 1 ? 's' : ''));
  return l;
}

const quand = (iso) => {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' }) + ' à ' + d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
};
const ancien = (iso) => { const d = new Date(iso); return !isNaN(d.getTime()) && Date.now() - d.getTime() > 3 * 86400000; };

const st = {
  panneau: { background: C.creme, border: `1px solid ${C.pale}`, borderRadius: 10, padding: '.7rem .8rem', marginTop: '.45rem' },
  petit: { fontSize: '.66rem', color: C.gris, lineHeight: 1.6 },
  btn: (actif = true, fond = C.brun) => ({ display: 'block', width: '100%', background: actif ? fond : C.pale, color: 'white', border: 'none', borderRadius: 9, padding: '.5rem', textAlign: 'center', fontSize: '.76rem', fontWeight: 600, cursor: actif ? 'pointer' : 'default', fontFamily: 'inherit' }),
  lien: { background: 'transparent', border: 'none', color: C.rose, fontSize: '.68rem', textDecoration: 'underline', cursor: 'pointer', fontFamily: 'inherit', padding: 0 },
  declencheur: { display: 'inline-flex', alignItems: 'center', gap: '.35rem', background: C.blanc, border: `1.5px solid ${C.rose}`, color: C.brun, borderRadius: 20, padding: '.35rem .85rem', fontSize: '.72rem', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' },
};

// ── Un favori à faire glisser dans la barre de favoris ──────────────────────
export function FavoriAGlisser({ code, libelle, couleur = C.brun }) {
  const ref = useRef(null);
  // React refuse les liens « javascript: » dans le JSX : on le pose directement sur l'élément.
  useEffect(() => { if (ref.current) ref.current.setAttribute('href', SCHEMA + code); }, [code]);
  return (
    <a ref={ref} href="#favori" onClick={(e) => e.preventDefault()} draggable="true" title="Fais-moi glisser dans ta barre de favoris"
      style={{ display: 'inline-block', background: couleur, color: 'white', borderRadius: 24, padding: '.55rem 1.1rem', fontSize: '.82rem', fontWeight: 700, textDecoration: 'none', cursor: 'grab', boxShadow: '0 3px 10px rgba(61,31,14,.25)', border: '2px dashed rgba(255,255,255,.55)' }}>
      ⭐ {libelle}
    </a>
  );
}

// ── Carte d'import : favori + zone de collage ────────────────────────────────
export function ImportChiffresMihi({ uid, onSaved, sansFavori = false }) {
  const [texte, setTexte] = useState('');
  const [message, setMessage] = useState(null);
  const [occupe, setOccupe] = useState(false);
  const [codeCopie, setCodeCopie] = useState(false);
  const lienRef = useRef(null);
  const chiffres = useChiffresMihi(uid);

  // React refuse les liens « javascript: » dans le JSX : on le pose directement sur l'élément.
  useEffect(() => { if (lienRef.current) lienRef.current.setAttribute('href', SCHEMA + RACCOURCI_CODE); }, []);

  const enregistrer = async () => {
    setMessage(null); setOccupe(true);
    try {
      if (!uid) throw new Error('Connecte-toi pour enregistrer tes chiffres.');
      const p = lirePaquetEquipe(texte);
      let ancien = chiffres;
      try { ancien = (await lireStock(uid)) || chiffres; } catch (e) { /* on garde ce qu'on a */ }
      const data = { ...p, liens: (ancien && ancien.liens) || (chiffres && chiffres.liens) || {}, manuels: (ancien && ancien.manuels) || (chiffres && chiffres.manuels) || {} };
      await sauverStock(uid, data);
      setTexte('');
      setMessage('✅ ' + p.membres.length + ' personnes enregistrées' + (p.moi ? ' · ton statut : ' + (p.moi.statut || '—') : '') + '.');
      if (onSaved) onSaved(data);
    } catch (e) { setMessage('❌ ' + e.message); }
    setOccupe(false);
  };

  const copierCode = async () => {
    try { await navigator.clipboard.writeText(SCHEMA + RACCOURCI_CODE); setCodeCopie(true); setTimeout(() => setCodeCopie(false), 2500); } catch (e) { setMessage('Copie impossible : utilise plutôt le bouton à glisser dans ta barre de favoris.'); }
  };

  return (
    <div>
      {!sansFavori && (
        <>
          <div style={{ ...st.petit, color: C.texte, lineHeight: 1.7 }}>
            Aucun mot de passe : le favori lit ton espace Mihi <strong>dans ton navigateur</strong>, déjà connectée à <strong>ton</strong> compte.
            <div style={{ marginTop: '.35rem' }}><strong>Une seule fois :</strong> fais glisser ce bouton dans ta barre de favoris (Ctrl+Maj+B pour l'afficher).</div>
          </div>
          <div style={{ margin: '.45rem 0' }}>
            <a ref={lienRef} href="#chiffres" onClick={(e) => e.preventDefault()} draggable="true"
              style={{ display: 'inline-block', background: C.brun, color: 'white', borderRadius: 20, padding: '.35rem .9rem', fontSize: '.74rem', fontWeight: 700, textDecoration: 'none', cursor: 'grab' }}>
              ⭐ Lire mon équipe Mihi
            </a>
            <button onClick={copierCode} style={{ marginLeft: '.6rem', background: 'transparent', border: `1px solid ${C.pale}`, borderRadius: 20, padding: '.3rem .7rem', fontSize: '.66rem', color: C.brun, cursor: 'pointer', fontFamily: 'inherit' }}>
              {codeCopie ? '✅ Code copié' : 'Le glisser ne marche pas ? Copier le code'}
            </button>
          </div>
        </>
      )}
      <div style={{ ...st.petit, color: C.texte, lineHeight: 1.7, marginBottom: '.4rem' }}>
        <strong>À chaque fois :</strong> ① va sur mihi.care (connectée) ② clique sur le favori « Lire mon équipe Mihi » ③ « Copier » ④ colle ci-dessous.
      </div>
      <textarea value={texte} onChange={(e) => setTexte(e.target.value)} placeholder="Colle ici ce que le favori a copié sur mihi.care"
        style={{ width: '100%', height: 60, boxSizing: 'border-box', border: `1px solid ${C.pale}`, borderRadius: 8, padding: '.5rem', fontSize: '.68rem', fontFamily: 'monospace', color: C.texte, background: C.blanc, outline: 'none', marginBottom: '.45rem' }} />
      <button onClick={enregistrer} disabled={occupe || !texte.trim()} style={st.btn(!occupe && !!texte.trim())}>
        {occupe ? '⏳ Enregistrement…' : '💾 Enregistrer mes chiffres Mihi'}
      </button>
      {message && <div style={{ marginTop: '.5rem', fontSize: '.72rem', fontWeight: 600, color: message.startsWith('❌') ? '#B04040' : C.vert }}>{message}</div>}
      <div style={{ ...st.petit, marginTop: '.4rem' }}>Si le favori ne réagit pas : sur mihi.care, ouvre la console (F12), colle le code (sans le « javascript: » du début) et valide.</div>
    </div>
  );
}

export function PartageEquipeMihi({ uid, chiffres }) {
  const [etat, setEtat] = useState(null);          // null = fermé · { annuaire, ok, ... }
  const [coches, setCoches] = useState({});
  const [filtre, setFiltre] = useState('');
  const [occupe, setOccupe] = useState(false);
  const [bilan, setBilan] = useState(null);

  const preparer = async (data = chiffres) => {
    setOccupe(true); setBilan(null);
    try { const complet = await lireAnnuaireCommun(); const annuaire = filtrerAnnuaire(complet, uid); setEtat({ annuaire, complet, classe: classerPartage(data, annuaire, uid), chiffres: data }); }
    catch (e) { setBilan({ ok: false, erreur: e.message }); }
    setOccupe(false);
  };
  const lierEtRecalculer = async (p, id) => {
    const data = { ...etat.chiffres, liens: { ...(etat.chiffres.liens || {}), [cleNom(p.nom)]: id, ['uid:' + p.uid]: id } };
    setOccupe(true);
    try { await sauverStock(uid, data); } catch (e) { /* le lien sert quand même pour ce partage */ }
    setEtat({ annuaire: etat.annuaire, complet: etat.complet, classe: classerPartage(data, etat.annuaire, uid), chiffres: data });
    setOccupe(false);
  };
  const marquerPartage = async (p, valeur) => {
    setOccupe(true);
    const data = await marquerDistributrice(uid, etat.chiffres, p.nom, p.uid, valeur);
    setEtat({ annuaire: etat.annuaire, complet: etat.complet, classe: classerPartage(data, etat.annuaire, uid), chiffres: data });
    setOccupe(false);
  };
  const retirerPartage = async (p) => {
    setOccupe(true);
    const data = await retirerMarquage(uid, etat.chiffres, p.nom, p.uid);
    setEtat({ annuaire: etat.annuaire, complet: etat.complet, classe: classerPartage(data, etat.annuaire, uid), chiffres: data });
    setOccupe(false);
  };
  const classe = etat && etat.classe;
  const aEnvoyer = classe ? [...classe.sures, ...classe.aConfirmer.filter((x) => coches[x.uid])] : [];
  const partager = async () => {
    setOccupe(true); setBilan(null);
    try {
      const n = await partagerALEquipe(etat.chiffres, aEnvoyer, etat.complet);
      // les personnes confirmées sont mémorisées : plus jamais de question
      const liens = { ...(etat.chiffres.liens || {}) };
      aEnvoyer.forEach((x) => { liens['uid:' + x.uid] = x.membre.i; });
      try { await sauverStock(uid, { ...etat.chiffres, liens }); } catch (e) { /* facultatif */ }
      setBilan({ ok: true, n, ignorees: classe.inconnus.length + classe.aConfirmer.filter((x) => !coches[x.uid]).length });
      setEtat(null);
    } catch (e) { setBilan({ ok: false, erreur: e.message }); }
    setOccupe(false);
  };
  const q = jetons(filtre);
  const inconnusFiltres = classe ? classe.inconnus.filter((p) => !q.length || q.every((x) => jetons(p.nom).join(' ').includes(x))) : [];

  return (
    <div style={{ background: C.blanc, borderRadius: 10, padding: '.7rem .8rem', marginTop: '.7rem' }}>
      <div style={{ fontSize: '.62rem', fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', color: C.rose, marginBottom: '.35rem' }}>Option · partager à toute l'équipe</div>
      <div style={{ ...st.petit, marginBottom: '.5rem' }}>
        Envoie le volume de groupe (PGV) de chaque personne reconnue <strong>qui est dans ta lignée</strong> (tes filleules, directes ou non) : il remplit alors tout seul sa jauge. <strong>Aucun volume perso, aucune vente n'est envoyé.</strong>
        <strong> Une personne non reconnue n'est jamais touchée</strong>, et ce qu'une personne a tapé elle-même n'est pas effacé : les chiffres Mihi sont gardés à part et valables pour la période en cours.
      </div>
      {!etat && <button onClick={() => preparer()} disabled={occupe || !chiffres} style={st.btn(!occupe && !!chiffres, C.brun)}>{occupe ? '⏳ Analyse…' : '👥 Préparer le partage à l\'équipe'}</button>}
      {bilan && bilan.ok && <div style={{ marginTop: '.5rem', fontSize: '.72rem', color: C.vert, fontWeight: 700 }}>✅ Chiffres partagés pour {bilan.n} personne{bilan.n > 1 ? 's' : ''}. {bilan.ignorees ? bilan.ignorees + ' non touchée' + (bilan.ignorees > 1 ? 's' : '') + '.' : ''}</div>}
      {bilan && !bilan.ok && <div style={{ marginTop: '.5rem', fontSize: '.72rem', color: '#B04040', fontWeight: 600 }}>❌ {bilan.erreur}</div>}
      {classe && (
        <div style={{ marginTop: '.3rem' }}>
          <div style={{ background: C.creme, borderRadius: 8, padding: '.5rem .65rem', fontSize: '.72rem', color: C.texte, lineHeight: 1.7 }}>
            <div>✅ <strong>{classe.sures.length}</strong> personne{classe.sures.length > 1 ? 's' : ''} reconnue{classe.sures.length > 1 ? 's' : ''} avec certitude : seront mises à jour</div>
            <div>🟡 <strong>{classe.aConfirmer.length}</strong> à confirmer (ressemblance seulement) : décochées par défaut</div>
            <div>⚪ <strong>{classe.inconnus.length}</strong> non reconnue{classe.inconnus.length > 1 ? 's' : ''} : <strong>ne seront pas touchées</strong></div>
            {classe.manuelles && classe.manuelles.length > 0 && <div>🖐️ <strong>{classe.manuelles.length}</strong> distributrice{classe.manuelles.length > 1 ? 's' : ''} marquée{classe.manuelles.length > 1 ? 's' : ''} à la main</div>}
          </div>

          {classe.aConfirmer.length > 0 && (
            <div style={{ marginTop: '.5rem' }}>
              <div style={{ fontSize: '.7rem', fontWeight: 700, color: C.brun, marginBottom: '.25rem' }}>🟡 À confirmer <button onClick={() => { const t = {}; classe.aConfirmer.forEach((x) => { t[x.uid] = true; }); setCoches(t); }} style={{ ...st.lien, marginLeft: '.4rem' }}>tout cocher</button></div>
              <div style={{ border: `1px solid ${C.pale}`, borderRadius: 8, maxHeight: 170, overflowY: 'auto' }}>
                {classe.aConfirmer.map((x) => (
                  <label key={x.uid} style={{ display: 'flex', gap: '.45rem', alignItems: 'center', padding: '.35rem .55rem', borderBottom: `1px solid ${C.pale}`, fontSize: '.7rem', color: C.texte, cursor: 'pointer' }}>
                    <input type="checkbox" checked={!!coches[x.uid]} onChange={(e) => setCoches((c) => ({ ...c, [x.uid]: e.target.checked }))} />
                    <span style={{ flex: 1 }}><strong>{x.nom}</strong> <span style={{ color: C.gris }}>= {x.membre.n}</span></span>
                    <span style={{ color: C.gris, whiteSpace: 'nowrap' }}>VGP {fmtE(x.membre.vgp)}</span>
                  </label>
                ))}
              </div>
            </div>
          )}

          <ListeMarqueesMihi liste={classe.manuelles} disabled={occupe} onChanger={marquerPartage} onRetirer={retirerPartage} />

          {classe.inconnus.length > 0 && (
            <div style={{ marginTop: '.5rem' }}>
              <div style={{ fontSize: '.7rem', fontWeight: 700, color: C.brun, marginBottom: '.25rem' }}>⚪ Non reconnues (relie-les si elles sont dans ton équipe Mihi)</div>
              <input type="text" value={filtre} onChange={(e) => setFiltre(e.target.value)} placeholder="🔍 Chercher une personne de l'app"
                style={{ width: '100%', boxSizing: 'border-box', border: `1px solid ${C.pale}`, borderRadius: 6, padding: '.4rem .5rem', fontSize: '.72rem', fontFamily: 'inherit', color: C.texte, background: C.creme, outline: 'none', marginBottom: '.25rem' }} />
              <div style={{ border: `1px solid ${C.pale}`, borderRadius: 8, maxHeight: 220, overflowY: 'auto' }}>
                {inconnusFiltres.slice(0, 25).map((p) => (
                  <div key={p.uid} style={{ padding: '.35rem .55rem', borderBottom: `1px solid ${C.pale}`, fontSize: '.7rem', color: C.texte }}>
                    <div style={{ fontWeight: 600 }}>{p.nom} <span style={{ fontWeight: 400, color: C.gris }}>→ qui est-ce sur Mihi ? (ou laisse vide)</span></div>
                    <ChoixPersonneMihi chiffres={etat.chiffres} candidats={p.candidats} disabled={occupe} onChoisir={(id) => lierEtRecalculer(p, id)} onManuel={(v) => marquerPartage(p, v)} />
                  </div>
                ))}
                {inconnusFiltres.length > 25 && <div style={{ padding: '.35rem .55rem', ...st.petit }}>… et {inconnusFiltres.length - 25} autres : précise ta recherche.</div>}
                {!inconnusFiltres.length && <div style={{ padding: '.35rem .55rem', ...st.petit }}>Personne.</div>}
              </div>
            </div>
          )}

          <button onClick={partager} disabled={occupe || !aEnvoyer.length} style={{ ...st.btn(!occupe && aEnvoyer.length > 0, C.vert), marginTop: '.6rem' }}>
            {occupe ? '⏳ Envoi…' : `✅ Partager les chiffres de ${aEnvoyer.length} personne${aEnvoyer.length > 1 ? 's' : ''}`}
          </button>
          <button onClick={() => setEtat(null)} style={{ ...st.lien, marginTop: '.4rem' }}>Annuler</button>
        </div>
      )}
    </div>
  );
}

// ── Carte bien visible en haut de l'Espace Chef : les favoris à glisser + le collage ──
export function CarteFavorisMihi({ uid, avecCatalogue = false }) {
  const [copie, setCopie] = useState('');
  const [auto, setAuto] = useState(true);
  const [occupe, setOccupe] = useState(false);
  const [bilan, setBilan] = useState(null);
  const chiffres = useChiffresMihi(uid);
  const toutRemplir = async (data) => {
    setOccupe(true); setBilan(null);
    try { setBilan({ ok: true, r: await appliquerPartout(uid, data) }); } catch (e) { setBilan({ ok: false, erreur: e.message }); }
    setOccupe(false);
  };
  // Relier à la main une personne que l'app n'a pas reconnue, puis relancer le remplissage
  const lierManquant = async (m, id) => {
    if (!id || !chiffres) return;
    const data = { ...chiffres, liens: { ...(chiffres.liens || {}), [cleNom(m.nom)]: id, ...(m.uid ? { ['uid:' + m.uid]: id } : {}) } };
    setOccupe(true);
    try { await sauverStock(uid, data); } catch (e) { /* le remplissage utilise quand même ce lien */ }
    setOccupe(false);
    await toutRemplir(data);
  };
  const marquerManquant = async (m, valeur) => {
    if (!chiffres) return;
    setOccupe(true);
    const data = await marquerDistributrice(uid, chiffres, m.nom, m.uid, valeur);
    setOccupe(false);
    await toutRemplir(data);
  };
  const copier = async (cle, code) => {
    try { await navigator.clipboard.writeText(SCHEMA + code); setCopie(cle); setTimeout(() => setCopie(''), 2500); } catch (e) { /* sans effet */ }
  };
  const etape = (n, t) => (
    <div style={{ display: 'flex', gap: '.5rem', alignItems: 'flex-start', marginBottom: '.3rem' }}>
      <span style={{ flexShrink: 0, width: 20, height: 20, borderRadius: '50%', background: C.rose, color: 'white', fontSize: '.65rem', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{n}</span>
      <span style={{ fontSize: '.72rem', color: C.texte, lineHeight: 1.5 }}>{t}</span>
    </div>
  );
  return (
    <div style={{ background: 'linear-gradient(135deg,#FFF6F1,#FBEAE3)', border: `2px solid ${C.rose}`, borderRadius: 14, padding: '1rem', marginBottom: '1rem' }}>
      <div style={{ fontFamily: 'Georgia,serif', fontSize: '1.05rem', color: C.brun, marginBottom: '.15rem' }}>⭐ Mes favoris <em style={{ color: C.rose }}>Mihi</em></div>
      <div style={{ ...st.petit, marginBottom: '.7rem' }}>
        Pour récupérer tes chiffres sans les retaper, <strong>sans jamais donner ton mot de passe</strong>.
        {chiffres ? <> Derniers chiffres : <strong>{quand(chiffres.date)}</strong>{chiffres.periode ? <> (campagne {chiffres.periode})</> : null}.</> : null}
      </div>

      <div style={{ background: C.blanc, borderRadius: 10, padding: '.7rem .8rem', marginBottom: '.7rem' }}>
        <div style={{ fontSize: '.62rem', fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', color: C.rose, marginBottom: '.45rem' }}>Étape 1 · une seule fois</div>
        {etape(1, <>Affiche ta barre de favoris : appuie sur <strong>Ctrl + Maj + B</strong> (Mac : Cmd + Maj + B).</>)}
        {etape(2, <><strong>Attrape le bouton ci-dessous avec ta souris</strong> (clic gauche maintenu) et <strong>dépose-le dans la barre de favoris</strong>, tout en haut du navigateur.</>)}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '.6rem', alignItems: 'center', margin: '.6rem 0 .3rem' }}>
          <FavoriAGlisser code={RACCOURCI_CODE_EQUIPE} libelle="Lire mon équipe Mihi" />
          {avecCatalogue && <FavoriAGlisser code={CODE_CATALOGUE} libelle="Lire le catalogue Mihi" couleur={C.rose} />}
        </div>
        <div style={{ ...st.petit }}>
          ⬆️ Ça ne se glisse pas ? <button onClick={() => copier('eq', RACCOURCI_CODE_EQUIPE)} style={st.lien}>{copie === 'eq' ? '✅ code copié' : 'copier le code de « Lire mon équipe »'}</button>
          {avecCatalogue && <> · <button onClick={() => copier('cat', CODE_CATALOGUE)} style={st.lien}>{copie === 'cat' ? '✅ code copié' : 'copier le code de « Lire le catalogue »'}</button></>}
          {' '}puis crée un favori à la main (clic droit sur la barre de favoris → « Ajouter une page ») et colle ce code à la place de l'adresse.
        </div>
      </div>

      <div style={{ background: C.blanc, borderRadius: 10, padding: '.7rem .8rem' }}>
        <div style={{ fontSize: '.62rem', fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', color: C.rose, marginBottom: '.45rem' }}>{avecCatalogue ? 'Étape 2 · tes chiffres d\'équipe (à chaque mise à jour)' : 'Étape 2 · à chaque mise à jour'}</div>
        {etape(1, <>Va sur <strong>mihi.care</strong>, connectée à ton compte.</>)}
        {etape(2, <>Clique sur le favori <strong>« Lire mon équipe Mihi »</strong>, puis sur <strong>« Copier »</strong>.</>)}
        {etape(3, <>Reviens ici et colle (Ctrl + V) :</>)}
        <ImportChiffresMihi uid={uid} sansFavori onSaved={(data) => { if (auto) toutRemplir(data); }} />
        <label style={{ display: 'flex', alignItems: 'flex-start', gap: '.45rem', marginTop: '.55rem', fontSize: '.72rem', color: C.brun, fontWeight: 600, cursor: 'pointer' }}>
          <input type="checkbox" checked={auto} onChange={(e) => setAuto(e.target.checked)} style={{ marginTop: 3 }} />
          <span>Remplir aussi tout de suite mes écrans<span style={{ display: 'block', fontWeight: 400, color: C.gris, fontSize: '.66rem' }}>Objectifs (CA total), directeurs en place, directeurs à venir et tirelire « Mon équipe » (PGV de chaque personne). Tes « ventes perso » et ta tirelire de ventes ne sont jamais touchées.</span></span>
        </label>
        {chiffres && (
          <button onClick={() => toutRemplir(chiffres)} disabled={occupe} style={{ ...st.btn(!occupe, C.vert), marginTop: '.55rem' }}>
            {occupe ? '⏳ Remplissage…' : '✅ Tout remplir maintenant avec mes derniers chiffres'}
          </button>
        )}
        {bilan && bilan.ok && (
          <div style={{ marginTop: '.55rem', background: C.creme, borderRadius: 8, padding: '.55rem .7rem', fontSize: '.72rem', color: C.texte, lineHeight: 1.6 }}>
            {resumerRemplissage(bilan.r).length
              ? <div style={{ color: C.vert, fontWeight: 700 }}>✅ Mis à jour : {resumerRemplissage(bilan.r).join(' · ')}.</div>
              : <div style={{ color: C.gris }}>Rien à remplir pour l'instant : ajoute d'abord des personnes dans la tirelire, les directeurs ou les directeurs à venir.</div>}
            {bilan.r.tirelireIgnoree && <div style={{ color: '#B26A00' }}>⚠️ Ta tirelire n'est pas encore passée à la nouvelle période : ouvre-la une fois depuis l'accueil, puis relance « Tout remplir ».</div>}
            {bilan.r.manquants.length > 0 && chiffres && (
              <div style={{ marginTop: '.4rem' }}>
                <div style={{ color: '#B26A00', fontWeight: 700, marginBottom: '.3rem' }}>⚠️ {bilan.r.manquants.length} personne{bilan.r.manquants.length > 1 ? 's' : ''} pas reconnue{bilan.r.manquants.length > 1 ? 's' : ''} : relie-les toi-même, l'app s'en souviendra.</div>
                {bilan.r.manquants.map((mq) => {
                  const nom = mq.nom;
                  const cands = trouverPersonne(chiffres, nom, mq.uid).candidats;
                  return (
                    <div key={nom + '|' + (mq.uid || '')} style={{ background: C.blanc, border: `1px solid ${C.pale}`, borderRadius: 8, padding: '.4rem .55rem', marginBottom: '.3rem' }}>
                      <div style={{ fontWeight: 600 }}>{nom} <span style={{ fontWeight: 400, color: C.gris }}>→ qui est-ce sur Mihi ?</span></div>
                      <ChoixPersonneMihi chiffres={chiffres} candidats={cands} disabled={occupe} onChoisir={(id) => lierManquant(mq, id)} onManuel={(v) => marquerManquant(mq, v)} />
                    </div>
                  );
                })}
                <div style={{ color: C.gris, fontSize: '.64rem' }}>Pas sur Mihi (par exemple une personne hors de ton équipe) ? Laisse-la : tu peux taper son chiffre à la main dans l'écran concerné.</div>
              </div>
            )}
            <div style={{ color: C.gris, fontSize: '.64rem' }}>Reviens sur l'accueil ou sur Objectifs : les chiffres y sont.</div>
          </div>
        )}
        {bilan && !bilan.ok && <div style={{ marginTop: '.55rem', fontSize: '.72rem', color: '#B04040', fontWeight: 600 }}>❌ {bilan.erreur}</div>}
      </div>

      {avecCatalogue && (
        <div style={{ background: C.blanc, borderRadius: 10, padding: '.7rem .8rem', marginTop: '.7rem' }}>
          <div style={{ fontSize: '.62rem', fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', color: C.rose, marginBottom: '.45rem' }}>Étape 3 · le catalogue et les prix (quand les prix changent)</div>
          {etape(1, <>Sur <strong>mihi.care</strong>, clique cette fois sur le favori <strong>« Lire le catalogue Mihi »</strong>, puis sur <strong>« Copier »</strong>.</>)}
          {etape(2, <>Reviens ici et colle dans <strong>cette case-ci</strong> (pas dans celle des chiffres d'équipe) :</>)}
          <AdminMajCatalogue compact />
        </div>
      )}

      {chiffres && <PartageEquipeMihi uid={uid} chiffres={chiffres} />}
    </div>
  );
}

function EnteteChiffres({ chiffres, onActualiser, actualiser }) {
  if (!chiffres) return null;
  const vieux = ancien(chiffres.date);
  return (
    <div style={{ ...st.petit, marginBottom: '.5rem' }}>
      Chiffres Mihi du <strong>{quand(chiffres.date)}</strong>{chiffres.periode ? <> · campagne <strong>{chiffres.periode}</strong></> : null} · {chiffres.membres.length} personnes
      {chiffres.moi && chiffres.moi.statut ? <> · ton statut : <strong>{chiffres.moi.statut}</strong></> : null}
      {vieux ? <span style={{ color: '#B04040', fontWeight: 600 }}> · ⏳ un peu anciens</span> : null}
      {' '}<button onClick={onActualiser} style={st.lien}>{actualiser ? 'Annuler' : 'Actualiser'}</button>
    </div>
  );
}

// ── Choix d'une personne Mihi avec barre de recherche ────────────────────────
export function ChoixPersonneMihi({ chiffres, candidats = [], disabled = false, onChoisir, onManuel = null }) {
  const [q, setQ] = useState('');
  const [manuelOuvert, setManuelOuvert] = useState(false);
  const [pgv, setPgv] = useState('');
  const mots = jetons(q);
  const tous = (chiffres && chiffres.membres) || [];
  const correspond = (m) => { const t = jetons(m.n).join(' '); return mots.every((x) => t.includes(x)); };
  const liste = mots.length ? tous.filter(correspond) : candidats;
  const visibles = liste.slice(0, 8);
  return (
    <div style={{ marginTop: '.3rem' }}>
      <input type="text" value={q} disabled={disabled} onChange={(e) => setQ(e.target.value)}
        placeholder={candidats.length ? '🔍 Plusieurs possibilités : tape un nom pour chercher' : '🔍 Tape un prénom ou un nom pour chercher sur Mihi'}
        style={{ width: '100%', boxSizing: 'border-box', border: `1px solid ${C.pale}`, borderRadius: 6, padding: '.4rem .5rem', fontSize: '.72rem', fontFamily: 'inherit', color: C.texte, background: C.creme, outline: 'none' }} />
      {visibles.length > 0 && (
        <div style={{ border: `1px solid ${C.pale}`, borderRadius: 6, marginTop: '.2rem', background: C.blanc }}>
          {visibles.map((m) => (
            <button key={m.i} type="button" disabled={disabled} onClick={() => { setQ(''); onChoisir(m.i); }}
              style={{ display: 'flex', justifyContent: 'space-between', gap: '.5rem', width: '100%', textAlign: 'left', background: 'transparent', border: 'none', borderBottom: `1px solid ${C.pale}`, padding: '.4rem .55rem', fontSize: '.72rem', color: C.brun, cursor: 'pointer', fontFamily: 'inherit' }}>
              <span style={{ fontWeight: 600 }}>{!mots.length ? '✨ ' : ''}{m.n}</span>
              <span style={{ color: C.gris, fontSize: '.64rem', whiteSpace: 'nowrap' }}>{m.mn ? 'mentor : ' + m.mn : ''}</span>
            </button>
          ))}
        </div>
      )}
      {mots.length > 0 && liste.length > visibles.length && <div style={{ ...st.petit, marginTop: '.15rem' }}>… et {liste.length - visibles.length} autres : précise ta recherche.</div>}
      {mots.length > 0 && !liste.length && <div style={{ ...st.petit, marginTop: '.15rem', color: '#B04040' }}>Personne ne correspond sur Mihi. Vérifie l'orthographe, ou tape son chiffre à la main.</div>}
      {onManuel && (
        <div style={{ marginTop: '.3rem' }}>
          {!manuelOuvert
            ? <button type="button" disabled={disabled} onClick={() => setManuelOuvert(true)} style={st.lien}>🖐️ C'est une distributrice, Mihi ne la voit pas</button>
            : (
              <div style={{ background: C.creme, borderRadius: 6, padding: '.4rem .5rem' }}>
                <div style={st.petit}>Elle sera comptée comme distributrice dans l'app. Son volume de groupe (PGV) de la campagne est facultatif : tu pourras le mettre plus tard.</div>
                <div style={{ display: 'flex', gap: '.35rem', marginTop: '.3rem', alignItems: 'center' }}>
                  <input type="text" inputMode="decimal" value={pgv} disabled={disabled} onChange={(e) => setPgv(e.target.value)} placeholder="PGV en € (facultatif)"
                    style={{ flex: 1, boxSizing: 'border-box', border: `1px solid ${C.pale}`, borderRadius: 6, padding: '.35rem .5rem', fontSize: '.72rem', fontFamily: 'inherit', color: C.texte, background: C.blanc, outline: 'none' }} />
                  <button type="button" disabled={disabled} onClick={() => { onManuel(pgv); setManuelOuvert(false); setPgv(''); }} style={{ ...st.btn(!disabled, C.vert), width: 'auto', padding: '.35rem .7rem' }}>Valider</button>
                </div>
              </div>
            )}
        </div>
      )}
    </div>
  );
}

// ── Les distributrices marquées à la main : modifier leur PGV ou retirer le marquage ──
export function ListeMarqueesMihi({ liste, disabled = false, onChanger, onRetirer }) {
  const [vals, setVals] = useState({});
  if (!liste || !liste.length) return null;
  return (
    <div style={{ marginTop: '.5rem' }}>
      <div style={{ fontSize: '.7rem', fontWeight: 700, color: C.brun, marginBottom: '.25rem' }}>🖐️ Distributrices marquées à la main</div>
      <div style={{ border: `1px solid ${C.pale}`, borderRadius: 8, maxHeight: 200, overflowY: 'auto' }}>
        {liste.map((p) => (
          <div key={p.uid} style={{ display: 'flex', gap: '.35rem', alignItems: 'center', padding: '.35rem .55rem', borderBottom: `1px solid ${C.pale}`, fontSize: '.7rem', color: C.texte }}>
            <span style={{ flex: 1, fontWeight: 600 }}>{p.nom}</span>
            <input type="text" inputMode="decimal" disabled={disabled} value={vals[p.uid] != null ? vals[p.uid] : (p.vgp > 0 ? String(p.vgp) : '')} onChange={(e) => setVals((v) => ({ ...v, [p.uid]: e.target.value }))} placeholder="PGV €"
              style={{ width: 70, boxSizing: 'border-box', border: `1px solid ${C.pale}`, borderRadius: 6, padding: '.25rem .4rem', fontSize: '.68rem', fontFamily: 'inherit', background: C.blanc, outline: 'none' }} />
            <button type="button" disabled={disabled} onClick={() => onChanger(p, vals[p.uid] != null ? vals[p.uid] : (p.vgp > 0 ? String(p.vgp) : ''))} style={st.lien}>Enregistrer</button>
            <button type="button" disabled={disabled} onClick={() => onRetirer(p)} style={{ ...st.lien, color: '#B04040' }}>Retirer</button>
          </div>
        ))}
      </div>
      <div style={{ ...st.petit, marginTop: '.2rem' }}>Le PGV saisi ne vaut que pour la campagne en cours : à la suivante, l'app le remet à zéro toute seule (la personne reste distributrice).</div>
    </div>
  );
}

// ── Bouton « Remplir depuis Mihi » pour une liste de personnes ───────────────
export function BoutonRemplirMihi({ uid, items, onApply, decrire, titre = 'Remplir depuis Mihi', aide = null }) {
  const chiffres = useChiffresMihi(uid);
  const [ouvert, setOuvert] = useState(false);
  const [maj, setMaj] = useState(false);
  const [message, setMessage] = useState(null);
  const [liensTemp, setLiensTemp] = useState({});
  const [manuelsTemp, setManuelsTemp] = useState({});

  const liens = { ...((chiffres && chiffres.liens) || {}), ...liensTemp };
  const avecLiens = chiffres ? { ...chiffres, liens, manuels: { ...((chiffres && chiffres.manuels) || {}), ...manuelsTemp } } : null;
  const lignes = (items || []).map((it) => ({ it, ...trouverPersonne(avecLiens, it.nom, it.uid) }));
  const trouves = lignes.filter((l) => l.membre && !l.membre.vide);
  const manquants = lignes.filter((l) => !l.membre);

  const lier = async (it, id) => {
    const suite = { ...liensTemp, [cleNom(it.nom)]: id, ...(it.uid ? { ['uid:' + it.uid]: id } : {}) };
    setLiensTemp(suite);
    if (!id) return;
    try { await sauverStock(uid, { ...chiffres, liens: { ...((chiffres && chiffres.liens) || {}), ...suite } }); } catch (e) { /* le lien reste valable pour cette fois */ }
  };

  const marquerIci = async (it, valeur) => {
    const v = { vgp: nb(String(valeur == null ? '' : valeur).replace(',', '.')), date: Date.now(), periode: chiffres && chiffres.periode ? String(chiffres.periode) : '' };
    const suite = { ...manuelsTemp, [cleNom(it.nom)]: v, ...(it.uid ? { ['uid:' + it.uid]: v } : {}) };
    setManuelsTemp(suite);
    try { await sauverStock(uid, { ...chiffres, manuels: { ...((chiffres && chiffres.manuels) || {}), ...suite } }); } catch (e) { /* le marquage reste valable pour cette fois */ }
  };
  const appliquer = () => {
    if (!trouves.length) return;
    onApply(trouves.map((l) => ({ key: l.it.key, item: l.it, membre: l.membre })));
    setMessage('✅ ' + trouves.length + ' personne' + (trouves.length > 1 ? 's' : '') + ' remplie' + (trouves.length > 1 ? 's' : '') + (manquants.length ? ' · ' + manquants.length + ' à associer ou à taper à la main' : '') + '.');
  };

  return (
    <div style={{ marginBottom: '.7rem' }}>
      <button onClick={() => { setOuvert((o) => !o); setMessage(null); }} style={st.declencheur}>📥 {titre}</button>
      {ouvert && (
        <div style={st.panneau}>
          {aide && <div style={{ ...st.petit, marginBottom: '.4rem' }}>{aide}</div>}
          {chiffres === undefined && <div style={st.petit}>Chargement…</div>}
          {chiffres !== undefined && (!chiffres || maj) && <ImportChiffresMihi uid={uid} onSaved={() => { setMaj(false); }} />}
          {chiffres && (
            <>
              <EnteteChiffres chiffres={chiffres} actualiser={maj} onActualiser={() => setMaj((v) => !v)} />
              {!maj && (
                <>
                  {!lignes.length && <div style={st.petit}>Il n'y a encore personne dans cette liste.</div>}
                  {lignes.length > 0 && (
                    <div style={{ background: C.blanc, border: `1px solid ${C.pale}`, borderRadius: 8, maxHeight: 230, overflowY: 'auto' }}>
                      {lignes.map((l) => (
                        <div key={String(l.it.key)} style={{ padding: '.35rem .6rem', borderBottom: `1px solid ${C.pale}`, fontSize: '.7rem', color: C.texte }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', gap: '.5rem' }}>
                            <span style={{ fontWeight: 600 }}>{l.it.nom}</span>
                            {l.membre ? (l.membre.vide ? <span style={{ color: C.gris, textAlign: 'right' }}>🖐️ marquée à la main, sans chiffre</span> : <span style={{ color: C.vert, fontWeight: 600, textAlign: 'right' }}>✓ {decrire(l.membre)}</span>) : <span style={{ color: '#B04040' }}>pas encore associée</span>}
                          </div>
                          {!l.membre && <ChoixPersonneMihi chiffres={chiffres} candidats={l.candidats} onChoisir={(id) => lier(l.it, id)} onManuel={(v) => marquerIci(l.it, v)} />}
                        </div>
                      ))}
                    </div>
                  )}
                  <button onClick={appliquer} disabled={!trouves.length} style={{ ...st.btn(trouves.length > 0, C.vert), marginTop: '.55rem' }}>
                    ✅ Remplir les chiffres de {trouves.length} personne{trouves.length > 1 ? 's' : ''}
                  </button>
                  <div style={{ ...st.petit, marginTop: '.3rem', textAlign: 'center' }}>Tu peux toujours corriger un chiffre à la main ensuite.</div>
                </>
              )}
            </>
          )}
          {message && <div style={{ marginTop: '.5rem', fontSize: '.72rem', fontWeight: 600, color: C.vert }}>{message}</div>}
        </div>
      )}
    </div>
  );
}

// ── Bouton « Mes chiffres Mihi » (mon CA / mon volume perso) ─────────────────
export function BoutonMoiMihi({ uid, onApply, titre = 'Mes chiffres depuis Mihi', libelleBouton = '✅ Remplir mon CA total', note = null }) {
  const chiffres = useChiffresMihi(uid);
  const [ouvert, setOuvert] = useState(false);
  const [maj, setMaj] = useState(false);
  const [message, setMessage] = useState(null);
  const moi = chiffres && chiffres.moi;
  return (
    <div style={{ marginBottom: '.7rem' }}>
      <button onClick={() => { setOuvert((o) => !o); setMessage(null); }} style={st.declencheur}>📥 {titre}</button>
      {ouvert && (
        <div style={st.panneau}>
          {chiffres === undefined && <div style={st.petit}>Chargement…</div>}
          {chiffres !== undefined && (!chiffres || maj) && <ImportChiffresMihi uid={uid} onSaved={() => setMaj(false)} />}
          {chiffres && (
            <>
              <EnteteChiffres chiffres={chiffres} actualiser={maj} onActualiser={() => setMaj((v) => !v)} />
              {!maj && (moi ? (
                <>
                  <div style={{ background: C.blanc, border: `1px solid ${C.pale}`, borderRadius: 8, padding: '.5rem .7rem', fontSize: '.74rem', color: C.texte, lineHeight: 1.8 }}>
                    <div>💰 Volume du groupe (VG) : <strong>{fmtE(moi.vg)}</strong></div>
                    <div>👥 Volume de groupe perso (VGP) : <strong>{fmtE(moi.vgp)}</strong></div>
                  </div>
                  <div style={{ ...st.petit, marginTop: '.35rem' }}>{note || "Seul le volume de groupe est repris. Tes « ventes perso » et tes commandes restent à remplir par toi."}</div>
                  <button onClick={() => { onApply(moi); setMessage('✅ Rempli.'); }} style={{ ...st.btn(true, C.vert), marginTop: '.55rem' }}>{libelleBouton}</button>
                </>
              ) : (
                <div style={{ ...st.petit, color: '#B04040' }}>Je n'ai pas trouvé tes propres chiffres pour cette campagne. Actualise depuis mihi.care.</div>
              ))}
            </>
          )}
          {message && <div style={{ marginTop: '.5rem', fontSize: '.72rem', fontWeight: 600, color: C.vert }}>{message}</div>}
        </div>
      )}
    </div>
  );
}
